"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reviewerDetailsSchema = void 0;
const zod_1 = require("zod");
const contactDetails_schema_1 = require("./contactDetails.schema");
exports.reviewerDetailsSchema = zod_1.z
    .object({
    contact: contactDetails_schema_1.contactDetailsSchema,
    dueDate: zod_1.z.string().optional(),
    hasReviewed: zod_1.z.boolean(),
    isOverdue: zod_1.z.boolean(),
})
    .strict();
//# sourceMappingURL=reviewerDetails.schema.js.map